<h1 mat-dialog-title>
    {{'Device details'|translate}}: {{ resource.name }} ({{resource.serialNumber}})
</h1>
<div mat-dialog-content *ngIf="!loadingDetails">
    <span *ngIf="serviceDevice.heartbeatAt!=='0001-01-01T00:00:00Z'">
        <span *ngIf="serviceDevice.online" style="color: green;">
            <mat-icon>check</mat-icon> {{'Device is online'|translate}}<br/>
        </span>
        <span *ngIf="!serviceDevice.online" style="color: red;">
            <mat-icon>report_problem</mat-icon> {{'Device is offline'|translate}}<br/>
        </span>
    </span>

    <span *ngIf="!modules && serviceDevice.workout" style="color: red;">
        <mat-icon>fitness_center</mat-icon> {{'Training in progress'|translate}}<br/>
    </span>
    <span *ngIf="!modules && !serviceDevice.workout" style="color: green;">
        <mat-icon>check</mat-icon> {{'Free'|translate}}<br/>
    </span>

    <div class="cards" fxLayout="row wrap" *ngFor="let module of modules" fxLayout.xs="column wrap">
        <div class="card p-8" *ngFor="let slot of module.slots" fxFlex="30">
            <!-- PREVIEW -->
            <div class="card-preview" fxFlex="100">

                <div class="fuse-card" fxFlex="100">

                    <div class="p-16 pt-0">
                        <h4 *ngIf="slot.visibleNumber">{{'Number'|translate}}: {{slot.visibleNumber}}</h4>
                        <h4 *ngIf="!slot.visibleNumber">{{'Number'|translate}}: {{slot.number}}</h4>

                        <h5 *ngIf="slot.cardNumber">{{'Card number'|translate}}: {{ slot.cardNumber }}</h5>
                        <h5 *ngIf="!slot.cardNumber">{{ 'Free'|translate }}</h5>

                        <span *ngIf="slot.user">{{slot.user.firstName}} {{slot.user.lastName}}<br/></span>
                        <span *ngIf="slot.user && slot.user.email">{{slot.user.email}}<br/></span>
                        <span *ngIf="slot.user && slot.user.phone">{{slot.user.phone}}<br/></span>
                    </div>

                    <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <a mat-button mat-stroked-button color="primary" (click)="openSlot(module.id, slot.number)">Otwórz</a>
                        </div>

                    </div>

                </div>

            </div>
            <!-- / PREVIEW -->
        </div>


    </div>

    <!-- TRAINING HISTORY -->
    <div *ngIf="!loadingDetails" style="margin-top: 24px;">
        <h2>{{'Training History'|translate}}</h2>

        <div *ngIf="trainingsLoading" style="text-align: center; padding: 20px;">
            <mat-spinner [diameter]="40"></mat-spinner>
        </div>

        <div *ngIf="!trainingsLoading && trainings.length === 0" style="text-align: center; padding: 20px; color: gray;">
            {{'No training sessions found'|translate}}
        </div>

        <div *ngIf="!trainingsLoading && trainings.length > 0">
            <table class="table table-hover" style="width: 100%; margin-top: 16px;">
                <thead>
                <tr>
                    <th>{{'Date'|translate}}</th>
                    <th>{{'Customer'|translate}}</th>
                    <th style="text-align: center;">{{'Distance'|translate}} (km)</th>
                    <th style="text-align: center;">{{'Calories'|translate}}</th>
                    <th>{{'Status'|translate}}</th>
                    <th>{{'Actions'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let training of trainings">
                    <td>{{training.createdAt | date: 'd.MM.y H:mm':'UTC': 'pl'}}</td>
                    <td>
                        <span *ngIf="training.user">{{training.user.firstName}} {{training.user.lastName}}</span>
                        <span *ngIf="!training.user">-</span>
                    </td>
                    <td style="text-align: center;">{{training.metrics?.distance ? (training.metrics.distance / 100000 | number:'1.1-2') : '-'}}</td>
                    <td style="text-align: center;">{{training.metrics?.calories ? (training.metrics.calories | number:'1.0-0') : '-'}}</td>
                    <td>
                        <span *ngIf="training.isActive" style="color: green;">{{'Active'|translate}}</span>
                        <span *ngIf="!training.isActive" style="color: gray;">{{'Finished'|translate}}</span>
                    </td>
                    <td>
                        <button mat-icon-button [routerLink]="['/training-details', training.id]" matTooltip="{{'View Details'|translate}}">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- / TRAINING HISTORY -->
</div>
<div mat-dialog-content *ngIf="loadingDetails">
    {{'Loading data'|translate}}...
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">OK</button>
</div>
